/* SignIn2.js */
/* @author: anghello */

import React, { useState } from 'react';
import { Col, Row, Card, CardBody, Nav, NavLink, NavItem, TabContent, TabPane } from 'reactstrap';
import Strings from '../../../translations/Translations';
import PepBlastLogo from './assets/pepblast-sociallinks.png';
import backgroundImage from './assets/pb-slinks-login-bg.jpg';
import Illustration from './assets/sociallink_login.jpg';
import { FaCheckSquare } from 'react-icons/fa';
import PanelLogin from './PanelLogin.js';
import PanelSignUp from './PanelSignUp.js';
import './signin3.scss';

export default function SignIn3() {
  const [activeTab, setActiveTab] = useState('1');

  const containerStyle = { backgroundImage: `url(${backgroundImage})` };

  const Icon1 = () => <FaCheckSquare style={{ color: '#23d959', fontSize: '22px' }} />;

  return (
    <div className='signin-2' style={containerStyle}>
      <Row className='full-height justify-content-center align-items-stretch'>

        <Col lg={12} className='d-flex justify-content-center align-items-center'>
          <Card className='shadow border-radius-4px card-features'>
            <CardBody className='p-0'>
              <Row className='m-0'>

                <Col md={6} className='left-panel'>
                  <div className='mb-4 px-4'>
                    <img src={PepBlastLogo} alt='PepBlast' className='img-fluid' />
                  </div>

                  <div className='px-5 mb-4 d-flex justify-content-center'>
                    <img src={Illustration} alt='Illustration' className='img-fluid illustration' />
                  </div>

                  <div>
                    <ul className='p-0'>
                      <li><Icon1 /> {Strings('signin_feat_1')}</li>
                      <li><Icon1 /> {Strings('signin_feat_2')}</li>
                      <li><Icon1 /> {Strings('signin_feat_3')}</li>
                      <li><Icon1 /> {Strings('signin_feat_4')}</li>
                      <li><Icon1 /> {Strings('signin_feat_5')}</li>
                      <li><Icon1 /> {Strings('signin_feat_6')}</li>
                      <li><Icon1 /> {Strings('signin_feat_7')}</li>
                    </ul>
                  </div>
                </Col>

                <Col md={6} className='right-panel d-flex align-items-center'>
                  <div>
                    <div className='mb-5 px-4 logo-container'>
                      <img src={PepBlastLogo} alt='PepBlast' className='img-fluid' />
                    </div>

                    <Nav justified className='nav-signin mb-3'>
                      <NavItem>
                        <NavLink className={`${(activeTab === '1') ? 'active' : ''}`} onClick={() => setActiveTab('1')}>
                          {Strings('sign_in')}
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink className={`${(activeTab === '2') ? 'active' : ''}`} onClick={() => setActiveTab('2')}>
                          {Strings('sign_up')}
                        </NavLink>
                      </NavItem>
                    </Nav>
                    <TabContent activeTab={activeTab}>
                      <TabPane tabId='1'>
                        <PanelLogin />
                      </TabPane>
                      <TabPane tabId='2'>
                        <PanelSignUp />
                      </TabPane>
                    </TabContent>

                    <div className='text-center text-muted opacity-8 mt-3'>
                      <small className='font-size-14px'>&copy; {new Date().getFullYear()} Photozig, Inc.</small>
                    </div>
                  </div>
                </Col>

              </Row>

            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
}
